import React from 'react';

function IndianCurrencyFormatter ({ amount }) {
  const formattedAmount = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  return <span>{formattedAmount}</span>;
};

function FormatDate(dateString) {
    const date = new Date(dateString);
  
    // Format the date in `24-01-2025 05:06 AM`
    const formattedDate = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // 12-hour format with AM/PM
    }).format(date);
  
    return formattedDate;
  }

export {
    IndianCurrencyFormatter,FormatDate
}
